import {
    Component,
    ElementRef,
    EventEmitter,
    Input,
    OnChanges,
    OnInit,
    Output,
    SimpleChanges,
    ViewChild,
} from '@angular/core';

@Component({
    selector: 'zt-simple-waveform-viewer',
    templateUrl: 'zt-simple-waveform-viewer.component.html',
    styleUrls: ['zt-simple-waveform-viewer.component.scss'],
})
export class ZtSimpleWaveformViewerComponent implements OnInit, OnChanges {
    @Input() blob?: Blob;
    @Input() play: boolean = true;
    @Input() stop: boolean = false;
    @Input() pause: boolean = false;
    @Input() showControls = false;
    @Input() showWaveform = true;

    @Output() onFinish = new EventEmitter();
    @Output() onPause = new EventEmitter();

    @ViewChild('audioTag') audioTag!: ElementRef;
    @ViewChild('canvas') canvasTag!: ElementRef;

    audioSource = '';
    audioContext!: AudioContext;

    ngOnInit() {
        this.audioContext = new (window.AudioContext ||
            (window as any).webkitAudioContext)();
        if (this.blob) {
            const reader = new FileReader();
            reader.addEventListener('loadend', (event) => {
                this.audioSource = '' + reader.result;
                if (this.showWaveform) {
                    this.displaySimpleWaveform();
                }
                const audioElement = this.audioTag
                    .nativeElement as HTMLAudioElement;
                audioElement.src = this.audioSource;
                audioElement.addEventListener('ended', () => {
                    this.onFinish.emit();
                });
                audioElement.addEventListener('pause', () => {
                    // this.onFinish.emit();
                    this.onPause.emit();
                });
                if (this.play) {
                    audioElement.play();
                }
            });
            reader.readAsDataURL(new Blob([this.blob], { type: 'audio/wav' }));
        }
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes) {
            const stopNewVal = changes['stop']?.currentValue;
            const playNewVal = changes['play']?.currentValue;
            const pauseNewVal = changes['pause']?.currentValue;
            if (stopNewVal == true && !changes['stop']?.firstChange) {
                const audioElement = this.audioTag
                    .nativeElement as HTMLAudioElement;
                audioElement.pause();
                audioElement.currentTime = 0;
            }
            if (playNewVal == true && !changes['play']?.firstChange) {
                const audioElement = this.audioTag
                    .nativeElement as HTMLAudioElement;
                audioElement.play();
            }
            if (pauseNewVal == true && !changes['pause']?.firstChange) {
                const audioElement = this.audioTag
                    .nativeElement as HTMLAudioElement;
                audioElement.pause();
            }
        }
    }

    displaySimpleWaveform() {
        const analyser = this.audioContext.createAnalyser();
        analyser.minDecibels = -90;
        analyser.maxDecibels = -10;
        analyser.smoothingTimeConstant = 0.85;

        const gainNode = this.audioContext.createGain();

        const source = this.audioContext.createMediaElementSource(
            this.audioTag.nativeElement as HTMLAudioElement
        );

        source.connect(gainNode);
        gainNode.connect(analyser);
        analyser.connect(this.audioContext.destination);

        const canvas = this.canvasTag.nativeElement as HTMLCanvasElement;
        const canvasCtx =
            canvas.getContext('2d') ?? new CanvasRenderingContext2D();

        const WIDTH = canvas.width;
        const HEIGHT = canvas.height;

        analyser.fftSize = 2048;
        var bufferLength = analyser.fftSize;
        var dataArray = new Uint8Array(bufferLength);

        canvasCtx?.clearRect(0, 0, WIDTH, HEIGHT);

        var draw = function () {
            const drawVisual = requestAnimationFrame(draw);

            analyser.getByteTimeDomainData(dataArray);

            canvasCtx.fillStyle = 'white';
            canvasCtx.fillRect(0, 0, WIDTH, HEIGHT);

            canvasCtx.lineWidth = 2;
            canvasCtx.strokeStyle = 'rgb(0, 0, 0)';

            canvasCtx.beginPath();

            const sliceWidth = (WIDTH * 1.0) / bufferLength;
            let x = 0;

            dataArray.forEach((data, index) => {
                const v = data / 128.0;
                const y = (v * HEIGHT) / 2;

                if (index === 0) {
                    canvasCtx?.moveTo(x, y);
                } else {
                    canvasCtx?.lineTo(x, y);
                }

                x += sliceWidth;
            });

            canvasCtx?.lineTo(canvas.width, canvas.height / 2);
            canvasCtx?.stroke();
        };

        draw();
    }
}
